module.exports = __webpack_public_path__ + "img/icon-arrow-up.ad7d2bf7.svg";